import Login from "../pages/Authentication";
import Dashboard from "../pages/Dashboard";
import LeadsForm from "../pages/Form";
import { Redirect } from "react-router-dom";
import Report from "../pages/Report";
import Blogs from "../pages/Blogs";
import BlogForm from "../pages/BlogForm";
import BlogCategories from "../pages/BlogCategories";

const authenticatedRoute = [
    { path: '/dashboard', component: Dashboard },
    { path: '/form/:id', exact: true, component: LeadsForm },
    { path: '/form', component: LeadsForm },
    { path: '/report', component: Report },
    { path: '/blogs/new', exact: true, component: BlogForm },
    { path: '/blogs/:id/edit', exact: true, component: BlogForm },
    { path: '/blogs', component: Blogs },
    { path: '/blog-categories', component: BlogCategories },
    { path: "/", exact: true, component: () => <Redirect to="/dashboard" /> }
]

const publicRoutes = [
    { path: '/login', component: Login }
]

export { authenticatedRoute, publicRoutes }